<template>
  <el-dialog
    title="选择项目模板"
    :visible.sync="show"
    width="80%"
    append-to-body
    :before-close="handleClose"
    top="8vh"
    center>
    
    <div class="temp-pro">
      <div class="temp-item" :class="{'active':item.active}" @click="selectTemp(item)" v-for="(item,index) in caseList" :key="index">
        <div class="temp-item-content" :class="{'tempClass':item.bg}">
          <div v-if="!item.bg" class="res-item-text">限时免费</div>
          <img :src="item.url">
        </div>
        <div class="temp-item-bottom">{{item.name}}</div>
      </div>      
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="checkBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['dialogComponentShow'], //接受父组件传递过来的数据
  data() {
      return {
        show: false, //弹窗默认隐藏
        caseList: [],//服务模板列表
        modelProject: null,
      };
  },
  mounted() {
    //显示弹窗
    this.show = this.dialogComponentShow;

    let modelList = [];
    for(let pro of this.$store.state.caseList){      
      modelList.push({
        url: pro.imageUrl,
        name: pro.name,
        business: pro.business,
        active: false,
        modelType: "project",
        bg: false
      });
    }

    for(let key in this.$store.state.apiTemplateList){
      let temp = this.$store.state.apiTemplateList[key];
      modelList.push({
        url: temp.url,
        name: temp.name,
        business: temp.business,
        status: temp.status,        
        type: temp.type,
        proType: temp.proType,
        active: false,
        modelType: "temp",
        bg: true
      });
    }
    this.caseList = modelList;
  },
  methods: {
    selectTemp(obj){
      for(let l of this.caseList){
        l.active = false;
      }
      obj.active = true;
      this.modelProject = obj;
    },
    handleClose() {
        //关闭弹窗
        this.show = false
        this.$emit('closeDialog')
    },
    checkBtn() {
      //确定按钮
      if(!this.modelProject){
        this.$message({
          message: "请选择项目模板",
          type: 'warning'
        });
        return;
      }
      
      if(this.modelProject.modelType == "temp"){
        if(this.modelProject.status == 1){
          let storeStr = this.modelProject.business + "Edit";
          this.$router.push({name: storeStr, query:{id:null, type: this.modelProject.type, business: this.modelProject.business, proType: this.modelProject.proType}});
        }else{
          this.$alert('功能测试中，敬请期待', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }
      }else {
        this.loading = this.$loading({
          lock: true,
          text: '请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if (this.modelProject.business == "location") {
          this.createdLocation(this.modelProject);
        } else if (this.modelProject.business == "modbus") {
          this.createdModbus(this.modelProject);
        } else if (this.modelProject.business == "opc") {
          this.createdOPC(this.modelProject);
        } else if (this.modelProject.business == "bacnet") {
          this.createdBacnet(this.modelProject);
        }    
      }        
    },
    getList(){
      // 确定执行完成后的处理
      this.$emit('okDialog');
      this.handleClose();
    },
    createdLocation(obj){
        let _this = this;
        let formData = locationModelInfo(obj);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: 'post',
          url: _this.api.saveServerProject,
          data: formData,
          params: {
              uid: uid,
              tk: token,
          },
        }).then(function(res) {
          let data = res.data;
          if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
          } else if (data.code == 200) {
              _this.$message({
                  message: '智慧地铁数据采集创建成功!',
                  type: 'success'
              });
              _this.createdLocationQuery(obj, data.data.id);
          } else {
            if(_this.loading){
              _this.loading.close();
            }
            _this.$message.error(data.msg);
          }
        }).catch(function() {
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      },
      createdLocationQuery(obj, queryProId){
        let _this = this;
        let formData = locationQueryModelInfo(obj, queryProId);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: 'post',
          url: _this.api.saveServerProject,
          data: formData,
          params: {
            uid: uid,
            tk: token,
          },
        }).then(function(res) {
          _this.getList()
          if(_this.loading){
            _this.loading.close();
          }          
          let data = res.data;
          if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
          } else if (data.code == 200) {
            _this.$message({
              message: '智慧地铁数据查询创建成功!',
              type: 'success'
            });            
          } else {            
            _this.$message.error(data.msg);
          }
        }).catch(function() {
          _this.getList()
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      },
      createdModbus(obj) {
        let _this = this;
        let formData = modbusModelInfo(obj);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: 'post',
          url: _this.api.saveServerProject,
          data: formData,
          params: {
            uid: uid,
            tk: token
          },
        }).then(function(res) {
          let data = res.data;
          if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
          } else if (data.code == 200) {
              _this.$message({
                message: '智慧城市数据采集创建成功!',
                type: 'success'
              });
              _this.createdModbusQuery(obj, data.data.id);
          } else {
            if(_this.loading){
              _this.loading.close();
            }
            _this.$message.error(data.msg);
          }
        }).catch(function() {
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      },
      createdModbusQuery(obj, queryProId){
        let _this = this;
        let formData = modbusQueryModelInfo(obj, queryProId);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
            method: 'post',
            url: _this.api.saveServerProject,
            data: formData,
            params: {
                uid: uid,
                tk: token,
            },
        }).then(function(res) {
          _this.getList();
          if(_this.loading){
            _this.loading.close();
          }
          let data = res.data;
          if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
          } else if (data.code == 200) {
              _this.$message({
                  message: '智慧城市数据查询创建成功!',
                  type: 'success'
              });
              
          } else {
              _this.$message.error(data.msg);
          }
        }).catch(function() {
          _this.getList();
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      },
      createdOPC(obj){
        let _this = this;
        let formData = OPCModelInfo(obj);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
            method: 'post',
            url: _this.api.saveServerProject,
            data: formData,
            params: {
                uid: uid,
                tk: token,
            },
        }).then(function(res) {
          let data = res.data;
          if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
          } else if (data.code == 200) {
              _this.$message({
                  message: '智慧工厂数据采集创建成功!',
                  type: 'success'
              });
              _this.createdOPCQuery(obj, data.data.id);
          } else {
            if(_this.loading){
              _this.loading.close();
            }
            _this.$message.error(data.msg);
          }
        }).catch(function() {
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      },
      createdOPCQuery(obj, queryProId){
        let _this = this;
        let formData = OPCQueryModelInfo(obj, queryProId);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
            method: 'post',
            url: _this.api.saveServerProject,
            data: formData,
            params: {
              uid: uid,
              tk: token,
            },
        }).then(function(res) {
          _this.getList();                 
          if(_this.loading){
            _this.loading.close();
          }
          let data = res.data;
          if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
          } else if (data.code == 200) {
              _this.$message({
                  message: '智慧工厂数据查询创建成功!',
                  type: 'success'
              });              
          } else {
              _this.$message.error(data.msg);
          }
        }).catch(function() {
          _this.getList();
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      },
      createdBacnet(obj){
        let _this = this;
        let formData = bacnetModelInfo(obj);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
            method: 'post',
            url: _this.api.saveServerProject,
            data: formData,
            params: {
                uid: uid,
                tk: token,
            },
        }).then(function(res) {
            let data = res.data;
            if (data.code == -1) {
                window.location.href = _this.api.loginHtmlUrl;
            } else if (data.code == 200) {
                _this.$message({
                    message: '智慧园区数据采集创建成功!',
                    type: 'success'
                });
                _this.createdBacnetQuery(obj, data.data.id);
            } else {
              if(_this.loading){
                _this.loading.close();
              }
              _this.$message.error(data.msg);
            }
        }).catch(function() {
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      },
      createdBacnetQuery(obj, queryProId){
        let _this = this;
        let formData = bacnetQueryModelInfo(obj, queryProId);
        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
            method: 'post',
            url: _this.api.saveServerProject,
            data: formData,
            params: {
              uid: uid,
              tk: token,
            },
        }).then(function(res) {
          _this.getList();
          if(_this.loading){
            _this.loading.close();
          }
          let data = res.data;
          if (data.code == -1) {
              window.location.href = _this.api.loginHtmlUrl;
          } else if (data.code == 200) {
              _this.$message({
                  message: '智慧园区数据查询创建成功!',
                  type: 'success'
              });              
          } else {
              _this.$message.error(data.msg);
          }
        }).catch(function() {
          _this.getList();
          if(_this.loading){
            _this.loading.close();
          }
          commonErrorTip(_this);
        })
      }
  }
};
</script>

<style>
.model-title{
  background: #fc8e36;
  font-size: 16px;
  line-height: 30px;
}

.temp-pro{
  height: 450px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  overflow: auto;
}

.temp-item {
  width: 153px;
  height: 108px;
  background: #323232;
  position: relative;
  margin: 10px 16px;
  border-radius: 10px;
}

.temp-item.active {
    border: 2px solid #fc8e36;
    padding: 0px;
}

.temp-item-content{
  width: 100%;
  height: 85px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.res-item-text{
  position: absolute;
  bottom: 26px;
  left: 4px;
  font-size: 8px;
  z-index: 1;
  font-weight: bold;
  color: rgb(255 46 46);
  padding: 4px;
  background: #444;
  border-radius: 10px;
}

.temp-item-content img{
  position: absolute;
  width: 100%;
  height: 80%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.temp-item-bottom{
  text-align: center;
  position: absolute;
  /* background: #7e7e7e45; */
  color: #ddd;
  bottom: 0;
  width: 100%;
  height: 20%;
}
.tempClass{
  background: rgb(214 227 255)
}
</style>